import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { compose } from 'recompose';
// import Dock from 'react-dock';

import SignOutButton from './SignOut';
import * as routes from '../../constants/routes';
import { Button, Glyphicon } from 'react-bootstrap';
import '../../sass/Navigation.css';
import SessionStore from '../../stores/sessionStore';
// import { firebase } from '../../firebase';

// class Navigation extends React.Component<any,any> {

//   constructor(props:any) {
//     super(props);

//     this.state = {
//       isVisible: false
//     }
//   }

//   render() {
//     return (
//       <div id="Navigation">
//         { this.props.userData
//             ? <NavigationAuth userData={this.props.userData} />
//             : <NavigationNonAuth />
//         }
//       </div>
//     );
//   }
// }

const Navigation = ({ sessionStore }) =>
  <div id="Navigation">
    { sessionStore.authUser
        ? <NavigationAuth />
        : <NavigationNonAuth />
    }
  </div>

class NavigationAuth extends React.Component<any,any> {

  constructor(props:any) {
    super(props);

    this.state = {
      isVisible: false
    }

    // firebase.auth.onAuthStateChanged(authUser => {
    //   console.log("LOADED!");
    // });
  }

  render() {
    return (
      <div id='nav'>
        <Link to={routes.HOME}>
          <Button className='navBeginBtn button-blue'>Continue</Button>
        </Link>
        <SignOutButton />
        {/* <Button className='userSidePanelBtn' onClick={() => this.setState({isVisible:true})}><Glyphicon glyph="user" /></Button> */}
        {/* <Dock position='right' isVisible={this.state.isVisible}>
          <div id='sidePanel'>
            <div id='sidePanelTitle'>
              <p>User Settings</p>
              <div className='closeBtn' onClick={() => this.setState({ isVisible: !this.state.isVisible })}><Glyphicon glyph="remove" /></div>
            </div>
            <div onClick={() => this.setState({ isVisible: !this.state.isVisible })}>X</div>
            <div id='navigationManageLinks'>
              <div><Link to={routes.ACCOUNT}>Manage Account</Link></div>
              <SignOutButton />
            </div>
          </div>
        </Dock> */}
      </div>
    );
  }
}

const NavigationNonAuth = () =>
<div>
  <Link to={routes.SIGN_UP}>
    <Button className='navBeginBtn mainBtn button-blue'>Begin</Button>
  </Link>
  <Link to={routes.SIGN_IN}>
    <Button className='navSignUpBtn'>Sign in</Button>
  </Link>
</div>

export default compose(
  inject('sessionStore'),
  observer
)(Navigation);



// WEBPACK FOOTER //
// ./src/components/routes/Navigation.tsx